import type { App } from 'vue';
import {
  createModalController,
  ModalControllerKey,
} from './create-modal-controller';

export const provideModal = {
  install(app: App) {
    app.provide(ModalControllerKey, createModalController());
  },
};
